import React from 'react'

function PlanPriceSection({ plan, billingInfo, selectPlan }) {
    return (
        <div className="w-full xl:w-1/4 md:w-1/4 mr-auto">
            <div className="relative flex flex-col h-full p-8">
                <h1 className="flex items-end mx-auto font-semibold text-xl lg:text-2xl text-gray-900 tracking-tight">
                    {`₪${plan.price}`}<span className='text-base text-gray-600 font-normal pr-1'>/ לחודש</span>
                </h1>
                {
                    billingInfo &&
                    <>
                        {
                            (billingInfo.plan.plan === plan.plan && !billingInfo.subscription?.isTrial) ?
                                <div
                                    className='px-4 py-2 bg-white rounded-full border-dashed text-base sm:text-lg mt-2 text-center text-green-500 border-green-500 font-medium border-2'>
                                    החבילה שלכם
                                </div>
                                :
                                <button onClick={() => selectPlan(plan.plan)}
                                    disabled={billingInfo?.plan?.plan === plan.plan && !billingInfo?.subscription?.isTrial}
                                    className="disabled:opacity-30 px-4 py-2 text-base mt-3 sm:text-lg text-center font-primary font-medium text-white bg-green-500 rounded-full focus:outline-none hover:bg-green-600 w-full">
                                    בחירת חבילה
                                </button>
                        }
                    </>
                }

                <p className="mx-auto text-gray-600 mt-3 text-sm text-center">המחירים אינם כוללים מע״מ</p>
            </div>
        </div>
    )
}

export default PlanPriceSection